import { useFormik } from 'formik';
import { UserValidation } from '@/validations';

export interface AuthorizeUserInitValues {
  username: string;
  captcha: string;
}

export interface VerifyOtpInitValues {
  otp: string;
}

export interface RestPasswordInitValues {
  newPassword: string;
  confirmNewPassword: string;
}

export function useFormAuthorizeUser(onSubmit: (values: AuthorizeUserInitValues, helpers: any) => void) {
  return useFormik<AuthorizeUserInitValues>({
    onSubmit,
    validateOnMount: true,
    validationSchema: UserValidation.AuthorizeUser,
    initialValues: {
      username: '',
      captcha: '',
    },
  });
}

export function useFormVerifyOtp(onSubmit: (values: VerifyOtpInitValues, helpers: any) => void) {
  return useFormik<VerifyOtpInitValues>({
    onSubmit,
    validateOnMount: true,
    validationSchema: UserValidation.VerifyOtp,
    initialValues: {
      otp: '',
    },
  });
}

export function useFormRestPassword(onSubmit: (values: RestPasswordInitValues, helpers: any) => void) {
  return useFormik<RestPasswordInitValues>({
    onSubmit,
    validateOnMount: true,
    validationSchema: UserValidation.RestPassword,
    initialValues: {
      newPassword: '',
      confirmNewPassword: '',
    },
  });
}
